import {
	SET_BEST_SALE_ACTION,
	SET_CRM_SHOP_INFO_ACTION,
	SET_CRM_REWARD_DETAIL_ACTION
} from "../actions/HomePageAction/actionTypes";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const persistConfig = {
	key: "home",
	storage: storage
};

const initialState = {
	listBestSale: [],
	infoShop: {},
	crmRewardDetail: {}
};

const homePageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_BEST_SALE_ACTION: {
			return {
				...state,
				listBestSale: action.params.products
			};
		}

		// passwordType: NORMAL : bình thường | DEFAULT: mật khẩu mặc định | FORCE_UPDATE: force update mật khẩu | EXPIRED : hết hạn | ABOUT_TO_EXPIRE: sắp hết hạn
		case SET_CRM_SHOP_INFO_ACTION: {
			return {
				...state,
				// infoShop: { ...action.params, passwordType: "NORMAL" }
				infoShop: action.params
			};
		}

		case SET_CRM_REWARD_DETAIL_ACTION: {
			return {
				...state,
				crmRewardDetail: action.params
			};
		}

		default:
			return state;
	}
};

// export default homePageReducer;
export default persistReducer(persistConfig, homePageReducer);
